import { v4 as uuidv4 } from "uuid";
function chillHop() {
  return [
    {
      name: "Meadows",
      cover:
        "https://cms.chillhop.com/media/155/squarelbb0db71fd74f15627e9912ad2278c13cee72ac2d.jpg",
      artist: "Psalm Trees",
      audio: "https://stream.chillhop.com/mp3/7868",
      color: ["#205950", "#2ab3bf"],
      id: uuidv4(),
      active: true,
    },
    {
      name: "I Don't Want Love",
      cover:
        "https://cms.chillhop.com/media/78394/squarelb94d142b5f3d7085b4a908629bb18845295183c6.jpg",
      artist: "Aiguille",
      audio: "https://stream.chillhop.com/mp3/75526",
      color: ["#7660A3", "#56414E"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Keep Going",
      cover:
        "https://cms.chillhop.com/media/6816/squarelff35dede32321a8aa0953809812941bcf8a6bd35.jpg",
      artist: "Swørn",
      audio: "https://stream.chillhop.com/mp3/9222",
      color: ["#CD607D", "#c94043"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Hope It's Not",
      cover:
        "https://cms.chillhop.com/media/79291/squarel4416fe0abb0ce765cb58be4812a4ee0578ad794f.jpg",
      artist: "J.Folk",
      audio: "https://stream.chillhop.com/mp3/77541",
      color: ["#8A5F79", "#5B3E4A"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Slinky",
      cover:
        "https://cms.chillhop.com/media/73902/squarele901df78a5db2b019da97900e257fa913130b6ac.jpg",
      artist: "Axian, Lazlow",
      audio: "https://stream.chillhop.com/mp3/71629",
      color: ["#78746F", "#819A63"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Stay",
      cover:
        "https://cms.chillhop.com/media/69957/squarel4945cd7e50ca1777035c994140f6aaa70e6df5fb.jpg",
      artist: "Yasper",
      audio: "https://stream.chillhop.com/mp3/65411",
      color: ["#205950", "#2ab3bf"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Winter Shore",
      cover:
        "https://cms.chillhop.com/media/69955/squarel0a2c6003af19a23e13b38661569898344d7590a1.jpg",
      artist: "Leavv",
      audio: "https://stream.chillhop.com/mp3/65383",
      color: ["#C4CCE1", "#F4D6DE"],
      id: uuidv4(),
      active: false,
    },
    //ADD MORE HERE
  ];
}

export default chillHop;
